import { AxiosResponse } from "axios";
import { IField, IFieldResponseData } from "./../fields/types";
import { ActionType } from "./../types/store-types";

export type optionsResponse = AxiosResponse<{
    success: boolean;
    message: string;
    data: ISelectableOptionsRes;
}>;

export interface ISelectableOptionState {
    label: string;
    value: ISelectOptionValue;
    disabled: boolean;
    isOther: boolean;
}

export interface IInitialOptions {
    fieldId: IField["_id"];
}

export interface IDeleteBulkOptions {
    fieldId: IField["_id"];
}

export interface IInitOptions {
    list: IFieldResponseData[];
}

export interface ISelectableOptionsRes {
    fieldId: IField["_id"];
    options: IOptionsState[];
}

interface IAddOptionData {
    fieldId: IField["_id"];
    option: ISelectableOptionState;
    otherId?: string;
}

export interface IBulkOptions {
    label: string[];
}

export interface IAddBulkOptionsData {
    fieldId: IField["_id"];
    options: IBulkOptions;
}

interface IAddOptionSuccessData {
    fieldId: IField["_id"];
    options: IOptionsState[];
}

interface IFailureData {
    fieldId: IField["_id"];
    optionId?: string;
}

interface IDeleteOptionData {
    fieldId: IField["_id"];
    optionId: string;
}
interface IDeleteOptionSuccessData {
    fieldId: IField["_id"];
    options: IOptionsState[];
}

export interface IDuplicateOptions {
    fieldId: IField["_id"];
    options: IOptionsState;
}

interface IUpdateOptionRequestData {
    fieldId: IField["_id"];
    optionId: string;
    option: ISelectableOptionState;
}

interface IAddOtherOption {
    fieldId: IField["_id"];
}

export interface IBulkSelectableOptions {
    label: string[];
}

interface ISwitchOptionsData {
    fieldId: IField["_id"];
    newOptions: IBulkSelectableOptions;
}
export interface IOptionState {
    label: string;
    isOther?: boolean;
    value: ISelectOptionValue;
    disabled: boolean;
}

export interface IOptionsState {
    [id: string]: IOptionState;
}
export interface IFieldOptions {
    [id: string]: IOptionsState;
}

export interface IUpdateSingleOption {
    fieldId: string;
    optionId: string;
    newValue: IOptionState;
}
export interface IFieldOptionsState {
    options: IFieldOptions;
    disabled: boolean;
}

export interface ISelectOptionValueCustomModel {
    title: string;
    enabled?: boolean;
    value: string;
}

export interface ISelectOptionValue {
    price?: {
        enabled?: boolean;
        value?: string;
    };
    quantity?: {
        enabled?: boolean;
        value?: number;
    };
    allowSelectQuantity: boolean;
    custom?: ISelectOptionValueCustomModel[];
}

export enum SelectableOptionsActionTypes {
    INITIAL_OPTIONS = "SELECTABLE_OPTIONS.INITIAL_OPTIONS",

    INIT_OPTIONS = "SELECTABLE_OPTIONS.INIT_OPTIONS",

    ADD_OPTION_REQUEST = "SELECTABLE_OPTIONS.ADD_OPTION_REQUEST",
    ADD_OPTION_SUCCESS = "SELECTABLE_OPTIONS.ADD_OPTION_SUCCESS",
    ADD_OPTION_FAILURE = "SELECTABLE_OPTIONS.ADD_OPTION_FAILURE",

    ADD_OTHER_OPTION_REQUEST = "SELECTABLE_OPTIONS.ADD_OTHER_OPTION_REQUEST",

    DELETE_OPTION_REQUEST = "SELECTABLE_OPTIONS.DELETE_OPTION_REQUEST",
    DELETE_OPTION_SUCCESS = "SELECTABLE_OPTIONS.DELETE_OPTION_SUCCESS",
    DELETE_OPTION_FAILURE = "SELECTABLE_OPTIONS.DELETE_OPTION_FAILURE",

    UPDATE_OPTION_REQUEST = "SELECTABLE_OPTIONS.UPDATE_OPTION_REQUEST",
    UPDATE_OPTION = "SELECTABLE_OPTIONS.UPDATE_OPTION",
    UPDATE_OPTION_FAILURE = "SELECTABLE_OPTIONS.UPDATE_OPTION_FAILURE",

    SWITCH_OPTIONS = "SELECTABLE_OPTIONS.SWITCH_OPTIONS",
    DUPLICATE_OPTIONS = "SELECTABLE_OPTIONS.DUPLICATE_OPTIONS",
    DUPLICATE_FIELD_OPTIONS = "SELECTABLE_OPTIONS.DUPLICATE_FIELD_OPTIONS",

    ADD_BULK_OPTION_REQUEST = "SELECTABLE_OPTIONS.ADD_BULK_OPTION_REQUEST",
    ADD_BULK_OPTION_SUCCESS = "SELECTABLE_OPTIONS.ADD_BULK_OPTION_SUCCESS",
    ADD_BULK_OPTION_FAILURE = "SELECTABLE_OPTIONS.ADD_BULK_OPTION_FAILURE",

    DELETE_BULK_OPTION_REQUEST = "SELECTABLE_OPTIONS.DELETE_BULK_OPTION_REQUEST",
    DELETE_BULK_OPTION_SUCCESS = "SELECTABLE_OPTIONS.DELETE_BULK_OPTION_SUCCESS",
    DELETE_BULK_OPTION_FAILURE = "SELECTABLE_OPTIONS.DELETE_BULK_OPTION_FAILURE",
}

export type InitialOptionsActionType = ActionType<SelectableOptionsActionTypes.INITIAL_OPTIONS, IInitialOptions>;

export type InitOptionsActionType = ActionType<SelectableOptionsActionTypes.INIT_OPTIONS, IInitOptions>;

export type AddOptionRequestActionType = ActionType<SelectableOptionsActionTypes.ADD_OPTION_REQUEST, IAddOptionData>;
export type AddOptionSuccessActionType = ActionType<
    SelectableOptionsActionTypes.ADD_OPTION_SUCCESS,
    IAddOptionSuccessData
>;
export type AddOptionFailureActionType = ActionType<SelectableOptionsActionTypes.ADD_OPTION_FAILURE, IFailureData>;

export type AddBulkOptionRequestActionType = ActionType<
    SelectableOptionsActionTypes.ADD_BULK_OPTION_REQUEST,
    IAddBulkOptionsData
>;
export type AddBulkOptionSuccessActionType = ActionType<
    SelectableOptionsActionTypes.ADD_BULK_OPTION_SUCCESS,
    IAddOptionSuccessData
>;
export type AddBulkOptionFailureActionType = ActionType<
    SelectableOptionsActionTypes.ADD_BULK_OPTION_FAILURE,
    IFailureData
>;

export type DeleteOptionRequestActionType = ActionType<
    SelectableOptionsActionTypes.DELETE_OPTION_REQUEST,
    IDeleteOptionData
>;
export type DeleteOptionSuccessActionType = ActionType<
    SelectableOptionsActionTypes.DELETE_OPTION_SUCCESS,
    IDeleteOptionSuccessData
>;
export type DeleteOptionFailureActionType = ActionType<
    SelectableOptionsActionTypes.DELETE_OPTION_FAILURE,
    IFailureData
>;

export type UpdateOptionRequestActionType = ActionType<
    SelectableOptionsActionTypes.UPDATE_OPTION_REQUEST,
    IUpdateOptionRequestData
>;
export type UpdateOptionActionType = ActionType<SelectableOptionsActionTypes.UPDATE_OPTION, IUpdateSingleOption>;
export type UpdateOptionFailureActionType = ActionType<
    SelectableOptionsActionTypes.UPDATE_OPTION_FAILURE,
    IFailureData
>;

export type SwitchOptionsActionType = ActionType<SelectableOptionsActionTypes.SWITCH_OPTIONS, ISwitchOptionsData>;

export type DeleteBulkOptionRequestActionType = ActionType<
    SelectableOptionsActionTypes.DELETE_BULK_OPTION_REQUEST,
    IDeleteBulkOptions
>;
export type DeleteBulkOptionSuccessActionType = ActionType<
    SelectableOptionsActionTypes.DELETE_BULK_OPTION_SUCCESS,
    IDeleteOptionSuccessData
>;
export type DeleteBulkOptionFailureActionType = ActionType<
    SelectableOptionsActionTypes.DELETE_BULK_OPTION_FAILURE,
    IFailureData
>;

export type DuplicateOptionsActionType = ActionType<SelectableOptionsActionTypes.DUPLICATE_OPTIONS, IDuplicateOptions>;
export type DuplicateFieldOptionsActionType = ActionType<
    SelectableOptionsActionTypes.DUPLICATE_FIELD_OPTIONS,
    IDuplicateOptions
>;

export type AddOtherOptionActionType = ActionType<
    SelectableOptionsActionTypes.ADD_OTHER_OPTION_REQUEST,
    IAddOtherOption
>;
